import salesmanago from "@/assets/customers/salesmanago_cdp_marketing_automation_logo.png";
import luckyDuck from "@/assets/customers/Lucky_duck_games.png";
import zilch from "@/assets/customers/zilch-logo.png";
import tesco from "@/assets/customers/tesco_technology_logo.png";
import vizoo from "@/assets/customers/Vizoo.png";
import evolutionLabs from "@/assets/customers/Evolution-labs.png";
import exmetrics from "@/assets/customers/Exmetrics.png";
import bricksFigs from "@/assets/customers/BricsFigs.png";
import securitify from "@/assets/customers/protesterzy_pl_logo.png";
import mapp from "@/assets/customers/mapp.png";
import ea from "@/assets/customers/ea.png";
import teradata from "@/assets/customers/teradata.png";
import cisowianka from "@/assets/customers/cisowianka.png";
import drzewce from "@/assets/customers/drzewce.png";
import naleczowZdroj from "@/assets/customers/naleczow-zdroj.png";
import perlage from "@/assets/customers/perlage.png";

export type Customer = {
  name: string;
  logo: string;
  alt: string;
  invert?: boolean;
};

export const CUSTOMERS: Customer[] = [
  { name: "Bricks & Figs", logo: bricksFigs, alt: "Bricks & Figs" },
  { name: "Cisowianka", logo: cisowianka, alt: "Cisowianka" },
  { name: "Electronic Arts", logo: ea, alt: "Electronic Arts", invert: true },
  { name: "Evolution-labs.io", logo: evolutionLabs, alt: "Evolution-labs.io" },
  { name: "ExMetrics", logo: exmetrics, alt: "ExMetrics" },
  { name: "Lucky Duck Games", logo: luckyDuck, alt: "Lucky Duck Games" },
  { name: "Majątek Drzewce", logo: drzewce, alt: "Majątek Drzewce" },
  { name: "Mapp Digital", logo: mapp, alt: "Mapp Digital" },
  { name: "Nałęczów Zdrój", logo: naleczowZdroj, alt: "Nałęczów Zdrój" },
  { name: "Perlage", logo: perlage, alt: "Perlage" },
  { name: "SALESmanago", logo: salesmanago, alt: "SALESmanago" },
  { name: "Securitify", logo: securitify, alt: "Securitify" },
  { name: "Teradata", logo: teradata, alt: "Teradata" },
  { name: "Tesco Technology", logo: tesco, alt: "Tesco Technology" },
  { name: "Vizoo.io", logo: vizoo, alt: "Vizoo.io" },
  { name: "Zilch", logo: zilch, alt: "Zilch" },
];
